import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section className="relative w-full min-h-screen flex items-center bg-cream-50 overflow-hidden">
      {/* Background image with overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20technology%20composition%20with%20warm%20amber%20and%20gold%20tones%2C%20overlapping%20translucent%20shapes%20representing%20data%20flow%20and%20digital%20innovation%2C%20modern%20corporate%20style%2C%20clean%20sophisticated%20aesthetic%2C%20soft%20gradient%20with%20organic%20curves%20and%20structured%20elements%2C%20editorial%20design%20feel%2C%20high%20detail%2C%20harmonious%20composition%2C%20warm%20cream%20and%20terracotta%20accents%2C%20no%20text&width=1800&height=1200&seq=hero-intellivex-bg&orientation=landscape"
          alt=""
          aria-hidden
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-ink-950/50 via-ink-950/30 to-ink-950/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-6 md:px-10 lg:px-14 pt-20 md:pt-28 pb-16">
        <div className="max-w-7xl mx-auto flex flex-col items-center text-center">
          {/* Eyebrow */}
          <div className="inline-flex items-center gap-2 mb-6">
            <span className="w-2 h-2 rounded-full bg-amber-400"></span>
            <span className="text-xs md:text-sm font-medium tracking-[0.2em] uppercase text-amber-200">
              Utility Apps &amp; Digital Marketing
            </span>
          </div>

          {/* Headline */}
          <h1 className="font-display font-bold text-cream-50 leading-[1.08] tracking-tight text-4xl sm:text-5xl md:text-6xl lg:text-7xl max-w-4xl">
            We build &amp; grow
            <br />
            utility applications
          </h1>

          {/* Description */}
          <p className="mt-6 max-w-2xl text-sm md:text-base leading-relaxed text-cream-50/80">
            From mobile cleaners and system optimizers to AI-powered services — we develop, launch,
            and promote utility apps with full-cycle marketing under one roof.
          </p>

          {/* CTAs */}
          <div className="mt-8 flex flex-col sm:flex-row items-center gap-3 sm:gap-4">
            <Link
              to="/services"
              className="inline-flex items-center justify-center gap-2 bg-amber-500 hover:bg-amber-400 text-ink-950 px-7 py-3.5 rounded-full text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap"
            >
              Explore our services
              <i className="ri-arrow-right-line text-base"></i>
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 text-sm font-medium text-cream-50 hover:text-amber-300 transition-colors cursor-pointer whitespace-nowrap border border-cream-50/20 hover:border-amber-300/40 px-7 py-3.5 rounded-full"
            >
              Get in touch
            </Link>
          </div>
        </div>
      </div>

      {/* Scroll hint */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 hidden md:flex flex-col items-center gap-3 text-cream-50/50">
        <span className="text-[10px] uppercase tracking-[0.3em] font-medium">Scroll</span>
        <span className="w-[1px] h-8 bg-cream-50/30 rounded-full animate-pulse"></span>
      </div>
    </section>
  );
}